import React, { useState } from "react";
import PlaylistGrid from "./PlaylistGrid";
import DocumentsGrid from "./DocumentsGrid";
import SocialMedia from "./SocialMedia";
import TickerGrid from "./Ticker";

interface SchedularStep1Props {
  selected: string[];
  setSelected: React.Dispatch<React.SetStateAction<string[]>>;
}

const SchedularStep1: React.FC<SchedularStep1Props> = ({
  selected,
  setSelected,
}) => {
  const TABS = [
    { label: "Playlists", value: "playlist" },
    // { label: "Documents", value: "documents" },
    // { label: "Social Media", value: "socialMedia" },
    // { label: "Ticker", value: "ticker" },
  ];

  const [activeTab, setActiveTab] = useState(TABS[0]);

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex mb-2 border-b-2 border-primary-default shrink-0">
        {TABS.map((tab) => (
          <button
            key={tab.value}
            className={`px-4 py-2 rounded-t-lg font-medium transition-colors duration-150 ${
              activeTab.value === tab.value
                ? "text-white bg-primary-default"
                : "text-gray-600 bg-gray-100 hover:bg-gray-200"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="flex-1 min-h-0">
        {activeTab.value === "playlist" && (
          <PlaylistGrid
            selected={selected}
            onSelect={(id: string) =>
              setSelected((prev) =>
                prev.includes(id)
                  ? prev.filter((sid) => sid !== id)
                  : [...prev, id]
              )
            }
          />
        )}
        {activeTab.value === "documents" && <DocumentsGrid />}
        {activeTab.value === "socialMedia" && <SocialMedia />}
        {activeTab.value === "ticker" && <TickerGrid />}
      </div>
    </div>
  );
};

export default SchedularStep1;
